import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import {useAuth} from "../../../hooks/useAuth";
import {APIGetNotificationsVerifyEmail} from "../api/notifications";
import React from "react";
import Tooltip from "@mui/material/Tooltip";

const NotificationsSwitch = () => {
    const {user, update} = useAuth();
    const checked = user.emailNotifications;
    const tooltipMessage = user.emailNotifications ? "Notificările pe adresa ta de e-mail sunt activate." : "Activează pentru a permite transmiterea notificărilor pe adresa ta de e-mail."

    const sendNotificationEmailHandler = () => {
        update("loading", {show: true, modal: true});

        APIGetNotificationsVerifyEmail()
            .then((response) => {
                if (response.data.success) {
                    update("error", {
                        show: true,
                        title: "E-mailul a fost trimis cu succes!",
                        message: <>
                            <Typography variant="body1">
                                Verifică adresa de e-mail pentru activarea notificărilor. Codul de verificare este valabil 60 de minute.
                            </Typography>
                            <Typography variant="body1"><b>
                                Atenție! Verifică și folderul spam al e-mailului tău dacă nu regăsești mesajul de verificare.
                            </b></Typography>
                        </>,
                        icon: "fat envelope",
                        closable: true,
                        button: "Închide",
                    });
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch((err) => {
                if (err?.response?.status === 400) {
                    let errors = err.response.data.data;
                    update("error", {
                        show: true,
                        title: "E-mail activare notificări",
                        message: <>
                            <Typography variant="body1">
                                E-mailul pentru activarea notificărilor a fost deja trimis. Verifică folderul spam al e-mailului tău dacă nu regăsești mesajul de verificare.
                            </Typography>
                        </>,
                        icon: "fat envelope",
                        closable: true,
                        button: "Închide",
                    });
                } else {
                    update("error", {show: true, code: "A001"});
                }
            })
            .finally(() => update("loading", {show: false}));
    }

    const confirmSendNotificationEmailHandler = () => {
        if (checked) return;

        update("confirm",
            {
                show: true,
                title: "Activează notificările pe e-mail!",
                message: "Pentru a permite trimiterea notificărilor pe adresa ta de e-mail, apasă butonul de mai jos pentru validarea acesteia.",
                icon: "fat envelope",
                closable: true,
                returnFunction: (callback: Function) => {
                    sendNotificationEmailHandler();
                },
                buttonYes: "Trimite e-mail",
                buttonNo: "Închide",
            });
    }

    return (
        <Tooltip
            title={
                <Typography variant="body2" p={1} sx={{color: "primary.contrastText"}}>
                    {tooltipMessage}
                </Typography>
            }
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    mt: 2,
                }}
            >
                <Typography variant="body1" sx={{marginBottom: 0, marginRight: 3}}>
                    Notificări e-mail
                </Typography>
                <Switch
                    checked={checked}
                    color="success"
                    onChange={confirmSendNotificationEmailHandler}
                    inputProps={{'aria-label': 'controlled'}}
                    size="small"
                />
            </Box>
        </Tooltip>
    )
}

export default NotificationsSwitch;